import { useContext } from "react";
import jwtDecoded from 'jwt-decode';
import AuthContext from '../context/Auth/authContext';

const DecodedJWT = () => {
  const authContext = useContext(AuthContext)
  const { token } = authContext
  const decode = jwtDecoded(token)
  return decode
}

export default DecodedJWT